var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "flex flex-row justify-center gap-2" };
var _hoisted_3 = { class: "inline-text" };
var _hoisted_4 = { class: "inline-text" };
var _hoisted_5 = {
    key: 0,
    class: "inline-text"
};
var _hoisted_6 = { class: "inline-text" };
var _hoisted_7 = { class: "inline-text" };
var _hoisted_8 = { class: "flex flex-col mt-4 w-full" };
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", null, " Note legali e declinazione di responsabilità: Tutti i risultati dei calcoli della presente sezioni sono fornite a soli fini di supporto. I risultati non devono essere utilizzati per sostituire la valutazione medica. LE PRESENTI INFORMAZIONI NON SONO SOSTITUTIVE DEL GIUDIZIO CLINICO NÉ MIRANO A ORIENTARE LA CURA INDIVIDUALE DEI PAZIENTI IN ALCUN MODO. ", -1);
var _hoisted_10 = { class: "text-center" };
var _hoisted_11 = { class: "text-center mt-4" };
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import dosiInBaseAlPeso from "@/../../EshJSLib/models/form/dosiInBaseAlPeso.json";
import dosiVelocitaInfusione from "@/../../EshJSLib/models/form/dosiVelocitaInfusione.json";
import dosiGoccieMillilitri from "@/../../EshJSLib/models/form/dosiGoccieMililitri.json";
import calcolaGault from "@/../../EshJSLib/models/form/calcolaGault.json";
import calcolaCreat from "@/../../EshJSLib/models/form/calcolaCreat.json";
import calcolaEquazione from "@/../../EshJSLib/models/form/calcolaEquazione.json";
import baseAlPesoCalculator from "./DosiSection/baseAlPesoCalculator.vue";
import velocitaInfusioneCalculator from "./DosiSection/velocitaInfusioneCalculator.vue";
import gocceMilillitriCalculator from "./DosiSection/gocceMilillitriCalculator.vue";
import creatCalculator from "./ClearanceSection/creatCalculator.vue";
import equazioneCalculator from "./ClearanceSection/equazioneCalculator.vue";
import gaultCalculator from "./ClearanceSection/gaultCalculator.vue";
import CalculatorDescription from "./components/CalculatorDescription.vue";
import ScoresLink from "./components/ScoresLink.vue";
import { onMounted, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import BaseInput from "./components/BaseInput.vue";
import { RouterLink } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalcolatriceMedica',
    setup: function (__props) {
        var _this = this;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var router = useRouter();
        var isShownModalSub = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        function movePage() {
            router.push({ path: '/Registro/Paypal' });
        }
        function movePageHome() {
            router.go(-1);
        }
        var creatininemia = ref(1);
        var peso = ref(patient.value.tbl_parametri_vitalis[0].parametro_peso);
        var altezza = ref(patient.value.tbl_parametri_vitalis[0].parametro_altezza);
        var sesso = patient.value.paziente_sesso;
        var eta = patient.value.paziente_eta;
        var pesoValid = ref(" ");
        var altezzaValid = ref(" ");
        var creatinemiaValid = ref(" ");
        var BMI = (peso.value / ((altezza.value * altezza.value) / 10000)).toFixed(2);
        var BMIvalue = ref(BMI);
        var powerAltezza = Math.pow(altezza.value, 0.725);
        var powerPeso = Math.pow(peso.value, 0.425);
        var BSA = (0.007184 * powerAltezza * powerPeso).toPrecision(3);
        var BSAvalue = ref(BSA);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hasPermission('calcolatrice')];
                    case 1:
                        if (_a.sent()) {
                            store.fetchHasBledScoresRelatedData();
                            store.fetchCha2Ds2ScoresRelatedData();
                            store.fetchMeldScoresRelatedData();
                            store.fetchFraminghamScoresRelatedData();
                            store.fetchCardiovascolareRelatedData();
                        }
                        else {
                            isShownModalSub.alert = true;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        function checkInputValidity() {
            if (peso.value < 5 || peso.value > 400) {
                pesoValid.value =
                    "Inserisci un valore valido per il peso. Il valore deve essere compreso tra 5 e 400.";
            }
            else {
                BMIvalue.value = (+peso.value / ((+altezza.value * +altezza.value) / 10000)).toFixed(2);
                BSAvalue.value = (0.007184 * (Math.pow(+altezza.value, 0.725)) * (Math.pow(+peso.value, 0.425))).toPrecision(3);
                pesoValid.value = " ";
            }
            if (altezza.value < 50 || altezza.value > 220) {
                altezzaValid.value =
                    "Inserisci un valore valido per l'altezza. Il valore deve essere compreso tra 50 e 220.";
            }
            else {
                altezzaValid.value = " ";
                BMIvalue.value = (+peso.value / ((+altezza.value * +altezza.value) / 10000)).toFixed(2);
                BSAvalue.value = (0.007184 * (Math.pow(+altezza.value, 0.725)) * (Math.pow(+peso.value, 0.425))).toPrecision(3);
            }
            if (creatininemia.value < 0.1 || creatininemia.value > 13) {
                creatinemiaValid.value =
                    "Inserisci un valore valido per la creatinemia. Il valore deve essere compreso tra 0.1 e 13.";
            }
            else {
                creatinemiaValid.value = " ";
            }
        }
        var dataModelCompletati = new CollapsableModel();
        return function (_ctx, _cache) {
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Peso (in kg)",
                                placeholder: "50",
                                type: "number",
                                step: "0.1",
                                lang: "it",
                                modelValue: _unref(peso),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(peso) ? (peso).value = $event : peso = $event); }),
                                onValidateInput: checkInputValidity,
                                isInputValid: _unref(pesoValid)
                            }, null, 8, ["modelValue", "isInputValid"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Altezza (in cm)",
                                placeholder: "50",
                                step: "0.1",
                                lang: "it",
                                type: "number",
                                modelValue: _unref(altezza),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (_isRef(altezza) ? (altezza).value = $event : altezza = $event); }),
                                onValidateInput: checkInputValidity,
                                isInputValid: _unref(altezzaValid)
                            }, null, 8, ["modelValue", "isInputValid"])
                        ]),
                        (_ctx.$route.fullPath == '/CalcolatriceMedica/Clearance')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(BaseInput, {
                                label: "Indice di massa corporea BMI",
                                style: { "width": "150px" },
                                type: "number",
                                value: _unref(BMIvalue),
                                disabled: ""
                            }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(BaseInput, {
                                label: "Superficie corporea",
                                style: { "width": "150px" },
                                type: "number",
                                value: _unref(BSAvalue),
                                disabled: ""
                            }, null, 8, ["value"])
                        ])
                    ]),
                    (_ctx.$route.fullPath == '/CalcolatriceMedica/Dosi')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(CollapsibleItem, { data: _unref(dosiInBaseAlPeso) }, {
                                default: _withCtx(function () { return [
                                    _createVNode(baseAlPesoCalculator, {
                                        peso: _unref(peso),
                                        altezza: _unref(altezza)
                                    }, null, 8, ["peso", "altezza"])
                                ]; }),
                                _: 1
                            }, 8, ["data"]),
                            _createVNode(CollapsibleItem, { data: _unref(dosiVelocitaInfusione) }, {
                                default: _withCtx(function () { return [
                                    _createVNode(velocitaInfusioneCalculator, { peso: _unref(peso) }, null, 8, ["peso"])
                                ]; }),
                                _: 1
                            }, 8, ["data"]),
                            _createVNode(CollapsibleItem, { data: _unref(dosiGoccieMillilitri) }, {
                                default: _withCtx(function () { return [
                                    _createVNode(gocceMilillitriCalculator)
                                ]; }),
                                _: 1
                            }, 8, ["data"])
                        ], 64))
                        : (_ctx.$route.fullPath == '/CalcolatriceMedica/Clearance')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(CollapsibleItem, { data: _unref(calcolaGault) }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(gaultCalculator, {
                                            altezza: _unref(altezza),
                                            eta: _unref(eta),
                                            peso: _unref(peso),
                                            creatininemia: _unref(creatininemia),
                                            sesso: _unref(sesso)
                                        }, null, 8, ["altezza", "eta", "peso", "creatininemia", "sesso"])
                                    ]; }),
                                    _: 1
                                }, 8, ["data"]),
                                _createVNode(CollapsibleItem, { data: _unref(calcolaCreat) }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(creatCalculator, { creatininemia: _unref(creatininemia) }, null, 8, ["creatininemia"])
                                    ]; }),
                                    _: 1
                                }, 8, ["data"]),
                                _createVNode(CollapsibleItem, { data: _unref(calcolaEquazione) }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(equazioneCalculator, {
                                            creatininemia: _unref(creatininemia),
                                            sesso: _unref(sesso),
                                            eta: _unref(eta)
                                        }, null, 8, ["creatininemia", "sesso", "eta"])
                                    ]; }),
                                    _: 1
                                }, 8, ["data"])
                            ], 64))
                            : (_ctx.$route.fullPath == '/CalcolatriceMedica/calcoloScores')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(CalculatorDescription, { "calculator-description": "Di seguito si mettono a disposizione Scores calcolabili sulla base dei dati di un paziente" }),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_unref(RouterLink), {
                                            to: "/calcolatricemedica/calcoloScores/hasBledScore",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(ScoresLink, {
                                                    class: "w-full",
                                                    title: "HAS-BLED Score"
                                                })
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_unref(RouterLink), {
                                            to: "/calcolatricemedica/calcoloScores/chaDsVasScore",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(ScoresLink, {
                                                    class: "w-full",
                                                    title: "CHA₂DS₂-VASc Score"
                                                })
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_unref(RouterLink), {
                                            to: "/calcolatricemedica/calcoloScores/framinghamScore",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(ScoresLink, {
                                                    class: "w-full",
                                                    title: "Framingham Risk Score"
                                                })
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_unref(RouterLink), {
                                            to: "/calcolatricemedica/calcoloScores/meldScore",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(ScoresLink, {
                                                    class: "w-full",
                                                    title: "MELD Score"
                                                })
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_unref(RouterLink), {
                                            to: "/calcolatricemedica/calcoloScores/cardiovascolareScore",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(ScoresLink, {
                                                    class: "w-full",
                                                    title: "Score Cardiovascolare"
                                                })
                                            ]; }),
                                            _: 1
                                        })
                                    ])
                                ], 64))
                                : _createCommentVNode("", true),
                    _hoisted_9,
                    (isShownModalSub.alert)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 3,
                            onClose: _cache[4] || (_cache[4] = function ($event) { return (movePageHome()); })
                        }, {
                            body: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("button", {
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (movePageHome()); }),
                                        type: "button",
                                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                    }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (movePage()); }),
                                        type: "button",
                                        class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                    }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                                ])
                            ]; }),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
